// models
import UserModel from '@/models/General/GUser'
import PaymentConditionModel from '@/models/Purchase/PchPaymentCondition'
import PosCustomerCreditOptionModel from '@/models/POS/PosCustomerCreditOption'
import ProductModel from '@/models/Warehouse/WhProduct'

// definitions
import DispatchRequestDetailHeaders from '@/views/Warehouse/WhDispatchRequest/update/headers'
import ProductFilters from '@/views/Warehouse/WhProduct/list/filters'
import ProductHeaders from '@/views/Warehouse/WhProduct/list/headers'

// rules
import { date, required } from '@/services/validations'

//
export default ({ g_branch_office_id, readonly }) => [
    {
        name: 'sl_customer_rut',
        type: 'rut-field',
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            rules: [required],
            textFieldProps: {
                readonly: true,
            },
            label: 'Rut',
            readonly: true,
        },
    },
    {
        name: 'sl_customer_alias_name',
        type: 'text-field',
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            readonly: true,
            rules: [required],
            label: 'Alias',
        },
    },
    {
        name: 'sl_customer_branch_offices_address',
        type: 'text-field',
        flex: {
            sm6: true,
        },
        props: {
            readonly: true,
            rules: [required],
            label: 'Dirección',
        },
    },
    {
        name: 'g_seller_user_id',
        type: 'autocomplete-model',
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            itemText: 'full_name',
            itemValue: 'id',
            label: 'Vendedor',
            model: UserModel,
            noDataText: 'Sin empleados.',
            noObject: true,
            readonly: true,
            rules: [required],
        },
    },
    {
        name: 'pos_customer_credit_option_id',
        type: 'autocomplete-model',
        props: {
            itemText: 'credit_option',
            itemValue: 'id',
            label: 'Condición de pago',
            model: PosCustomerCreditOptionModel,
            //multiple: true,
            noDataText: 'Sin tipos de pago.',
            noObject: true,
            paramSearch: 'credit_option',
            //readonly: true,
            rules: [required],
        },
    },
    {
        name: 'created_at',
        type: 'date-field',
        props: {
            fieldProps: {
                rules: [date, required],
            },
            label: 'Creado',
            pickerProps: {
                readonly: true,
            },
        },
    },
    {
        name: 'g_state_name',
        type: 'text-field',
        props: {
            label: 'Estado',
            readonly: true,
            rules: [required],
        },
    },
    {
        name: 'wh_selected_dispatch_requests',
        type: 'table-field',
        flex: {
            'd-grid': true,
            'pt-0': true,
            xs12: true,
        },
        props: {
            checkable: true,
            class: 'v-card elevation-2 mb-4',
            headers: DispatchRequestDetailHeaders,
            noActions: true,
            noDataText: 'Sin productos.',
            noFilter: true,
            noExport: true,
            noHelper: true,
            noPagination: true,
            noSearch: true,
            pickerProps: {
                filters: ProductFilters,
                headers: ProductHeaders,
                noPagination: false,
                mapper: row => {
                    //
                    row['g_branch_office_id'] = g_branch_office_id
                    row['quantity_requested'] = 0
                    //
                    return row
                },
                submitText: 'confirmar selección',
                service: ProductModel,
                title: 'Seleccionar producto',
            },
            showNativePagination: true,
            showPicker: true,
            toolbarTitle: 'Lista de productos incluidos en la solicitud',
            toolbarColor: 'primary',
            toolbarDark: true,
            toolbarDense: true,
            readonly,
            rules: [required],
        },
    },
    {
        name: 'sale_comment',
        type: 'textarea',
        flex: {
            xs12: true,
        },
        props: {
            label: 'Comentario Vendedor',
            readonly: true,
        },
    },
    {
        name: 'description',
        type: 'textarea',
        flex: {
            xs12: true,
        },
        props: {
            noDataText: 'Sin empleados.',
            label: 'Descripción',
            readonly,
            //rules: [required],
        },
    },
    {
        name: 'pos_sale_id',
        type: 'text-field',
        props: {
            label: 'Numero de ticket',
            readonly: true,
        },
    },
]
